module.exports = __webpack_public_path__ + "img/694.cc98b9f9.jpg";